/**
 * Created by akrio on 2018/3/23.
 */
import { postSignature, upload } from "../api/aws";
import {
  addGallery,
  delGallery as delGalleryRes,
  getGalleryList,
  getSavedList as getSavedListRes,
} from "../api/media";
import {
  md5,
  compressor,
  getVideoDimensions,
  canvasBlob,
  imageLoad,
  imageBlob,
  imgFilter,
  getInitImgParams,
  getImageCropPercentage,
} from "../utils/media";
import store from "../store/index";
import {
  MEDIA_LIBRARY_LIST,
  MEDIA_LIBRARY_PARAMS,
  SAVED_LIBRARY_LIST,
  SAVED_LIBRARY_PARAMS,
  CURRENT_USER_INFO_SIMPLE,
} from "../store/mutation-types";
import app from "../main";
import { Post } from "./model/post";
import axios from "axios";

const MEDIA_LIMIT = 35;

/**
 * media图片上传
 * @param file 文件
 * @param ins 是否压缩
 * @returns {Promise<*>}
 */
export async function uploadImg({ file, ins = false }) {
  // 如果发现是ins图片则对其进行必要压缩
  let f = file;
  if (ins) {
    f = await compressor({ image: file, ins });
  }
  // 获取当前登录人id
  const currentUser = store.getters[CURRENT_USER_INFO_SIMPLE];
  let currentUserId = "";
  if (currentUser) {
    currentUserId = currentUser.id;
  } else {
    console.error("无法获取当前登录人");
  }
  const key = await md5({ image: f });
  const { data: awsInfo } = await postSignature({
    key: `${currentUserId}/posts/${key}`,
  });
  await upload({
    url: awsInfo.url,
    key: awsInfo.fields.key,
    algorithm: awsInfo.fields["x-amz-algorithm"],
    credential: awsInfo.fields["x-amz-credential"],
    date: awsInfo.fields["x-amz-date"],
    acl: awsInfo.fields["acl"],
    contentType: awsInfo.fields["Content-Type"],
    policy: awsInfo.fields["policy"],
    signature: awsInfo.fields["x-amz-signature"],
    file: f,
  });
  return awsInfo.fields.key;
}

export function videoValidate({ ratio, duration, height, width }) {
  let errorMsg = "";
  let postSuccess =
    Number(ratio) > 0.79 && Number(ratio) < 1.92 && Number(duration) <= 60;
  // 同时验证尺寸是否符合要求
  if (postSuccess) {
    if (height === width) {
      postSuccess = height >= 320 && height <= 1080;
      if (!postSuccess) {
        errorMsg = `上传正方形视频失败，上传宽高为${height},要求(320-1080)`;
      }
    } else {
      postSuccess = width <= 1080 && height >= 566 && height <= 1350;
      if (!postSuccess) {
        errorMsg = `非正方形视频失败，上传宽为${width} 高为${height},要求宽小于1080 高(556-1350)`;
      }
    }
  } else {
    errorMsg = `post 视频尺寸无效，因为 比例(${ratio}) 或者 duration(${duration})无效，实际要求比例(0.79-1.92) 时长60秒以内`;
  }
  const storySuccess = Number(duration) <= 15;
  return {
    postSuccess,
    storySuccess,
    errorMsg,
  };
}

/**
 * 为media 添加图片
 * @param file 图片文件
 */
export async function uploadMedia({ file }) {
  let imageFile;
  let info;
  const mediaUrl = URL.createObjectURL(file);
  const msg =
    "Due to Instagram limitations, Apphi Desktop only supports .mp4 video format. POST videos with ratios 4:5 to 16:9 and 3 to 60 seconds, maximum width 1080 pixels. STORY videos with 9:16 and no longer than 15 seconds.\n\nPlease use Apphi APP to upload your video, edit, change cover, and schedule directly.";
  // 防止用户上传非mp4格式的视频
  if (file.type.includes("video/") && file.type !== "video/mp4") {
    app.$bus.$emit("showDownload", { msg });
    return Promise.resolve();
  }
  console.log("file.type", file.type);
  if (file.type === "video/mp4") {
    const video = document.getElementById("uploadVideo");
    video.src = mediaUrl;
    info = await getVideoDimensions({ video });
    const { postSuccess, storySuccess, errorMsg } = videoValidate(info);
    // 视频比例进行验证，0.79 - 1.92
    if (!postSuccess && !storySuccess) {
      console.error(info);
      console.error(`${errorMsg}`);
      app.$bus.$emit("showDownload", { msg });
      return Promise.resolve();
    }
    const canvas = document.createElement("canvas"); // 创建一个画布
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.id = mediaUrl;
    canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height); // getContext:设置画布环境；drawImage:画画
    imageFile = await canvasBlob({ canvas });
  } else {
    // 如果不是视频就是图片
    const image = await imageLoad({ src: mediaUrl });
    imageFile = file;
    info = { width: image.width, height: image.height };
  }
  const mediaLey = await uploadImg({ file });
  // 计算压缩图片
  const compressImg = await compressor({ image: imageFile });
  const coverKey = await uploadImg({ file: compressImg });
  console.log("获取缩略图", coverKey);
  const { data } = await addGallery({
    cover_key: coverKey,
    media_key: mediaLey,
    ...info,
    format: file.type,
  });
  const addItem = formatMediaLibraryItem(data);
  // 图片添加成功后加到缓存中
  let media = store.getters[MEDIA_LIBRARY_LIST];
  media.list = [addItem, ...media.list];
  media.count += 1;
  store.commit(MEDIA_LIBRARY_LIST, media);
  // 更新查询条件
  let params = store.getters[MEDIA_LIBRARY_PARAMS];
  params.offset += 1;
  // 保存查询属性
  store.commit(MEDIA_LIBRARY_PARAMS, params);
  return addItem;
}

/**
 * 获取Media Library列表
 * @param offset
 * @param limit
 */
export async function getMediaList({ offset = 0, limit = MEDIA_LIMIT }) {
  const { data } = await getGalleryList({ limit, offset });
  const result = {
    list: data.results.map(formatMediaLibraryItem),
    count: data.count,
    end: data.next === null,
  };
  return result;
}

/**
 * 删除media Library中任一项
 * @param ids
 * @returns {Promise<void>}
 */
export async function delGallery({ ids }) {
  const galleryIdList = ids.join(";");
  await delGalleryRes({ ids: galleryIdList });
  // 成功之后直接删除缓存中数据
  let media = store.getters[MEDIA_LIBRARY_LIST];
  media.count = media.count - ids.length;
  media.list = media.list.filter((m) => {
    return ids.find((i) => i === m.id) === undefined;
  });
  store.commit(MEDIA_LIBRARY_LIST, media);
  // 同时重置查询条件，offset
  let params = store.getters[MEDIA_LIBRARY_PARAMS];
  params.offset -= ids.length;
  // 保存查询属性
  store.commit(MEDIA_LIBRARY_PARAMS, params);
  /**
   * 判断删除后是否需要刷新
   * */
  // 如果显示数量等于数据库总数量则无需重新请求
  if (media.list.length < media.count) {
    // 判断已经删除的过少了，如果少于10条则重新请求
    if (media.list.length < 10) {
      // 如果需要刷新则进行广播
      app.$bus.$emit("mediaLibraryReload", {});
    }
  }
}

/**
 * 获取Media saved Library列表
 * @param offset
 * @param limit
 */
export async function getSavedList({ offset = 0, limit = MEDIA_LIMIT }) {
  const { data } = await getSavedListRes({ limit, offset });
  const result = {
    list: data.results.map(formatSaveMediaItem),
    count: data.count,
    end: data.next === null,
  };
  return result;
}

/**
 * 加载saved library
 * @param first 是否从头加载
 */
export async function loadSavedMore({ first = false }) {
  // 计算页码属性
  let params = store.getters[SAVED_LIBRARY_PARAMS];
  let saveLibraryList = store.getters[SAVED_LIBRARY_LIST].list;
  if (first) {
    params = {
      offset: 0,
      limit: MEDIA_LIMIT,
    };
    saveLibraryList = [];
  } else {
    params.offset += params.limit;
  }
  // 分页查询saved media library
  const saved = await getSavedList(params);
  // 保存查询属性
  store.commit(SAVED_LIBRARY_PARAMS, params);
  // 保存分页结果到store中
  saved.list = [...saveLibraryList, ...saved.list];
  store.commit(SAVED_LIBRARY_LIST, saved);
  return store.getters[SAVED_LIBRARY_LIST];
}

/**
 * 加载media library
 * @param first 是否从头加载
 */
export async function loadMore({ first = false }) {
  // 计算页码属性
  let params = store.getters[MEDIA_LIBRARY_PARAMS];
  let mediaLibraryList = store.getters[MEDIA_LIBRARY_LIST].list;
  if (first) {
    params = {
      offset: 0,
      limit: MEDIA_LIMIT,
    };
    mediaLibraryList = [];
  } else {
    params.offset += params.limit;
  }
  // 分页查询media library
  let media = await getMediaList(params);
  // 保存查询属性
  store.commit(MEDIA_LIBRARY_PARAMS, params);
  // 保存分页结果到store中
  media.list = [...mediaLibraryList, ...media.list];
  store.commit(MEDIA_LIBRARY_LIST, media);
  return store.getters[MEDIA_LIBRARY_LIST];
}

/**
 * 格式化media library格式
 * @param m 原始格式
 * @returns {{id, url: *, coverUrl: *}}
 */
export function formatMediaLibraryItem(m) {
  // 计算key
  const mediaKey = m.media_url.split("https://files.apphi.com/")[1];
  const coverKey = m.cover_url.split("https://files.apphi.com/")[1];
  let model = {
    id: m.id,
    url: m.media_url,
    coverUrl: m.cover_url,
    mediaKey,
    coverKey,
    crop: {
      filter: "normal",
      url: m.media_url,
      x: 0,
      y: 0,
      rotate: 0,
      scale: 1,
      percentage: 1, // 裁切框比例(宽高比)
      lock: false, // 锁定
    },
    duration: Number(m.duration),
    from: "add", // 来源
  };
  // 判断多媒体类型 视频
  if (m.is_video) {
    model.type = 2;
    const { postSuccess, storySuccess, errorMsg } = videoValidate(m);
    model.postVideo = postSuccess;
    model.storyVideo = storySuccess;
    model.videoMsg = errorMsg;
  }
  // 图片
  if (m.is_photo) {
    model.type = 1;
  }
  model.durationText = duration(model);
  model.story_mentions = [];
  model.story_hashtags = [];
  model.usertags = [];
  model.product_tags = [];
  return model;
}

/**
 * 计算播放时长
 */
function duration(item) {
  if (item.type === 2 && item.duration) {
    if (item.duration === 60) {
      return "01:00";
    } else {
      if (item.duration < 10) {
        return `00:0${item.duration}`;
      } else {
        return `00:${item.duration}`;
      }
    }
  }
  return "";
}

export function initImage(m) {
  let result = {
    id: m.id || m.key,
    url: m.url,
    coverUrl: m.cover_url || m.url,
    coverKey: m.cover_key || m.media_key || m.key,
    previewUrl: `${m.url}?t=${new Date().getTime()}`,
    type: m.type, // 类型
    key: m.media_key || m.key,
    crop: {
      filter: "normal",
      url: m.url,
      x: 0,
      y: 0,
      rotate: 0,
      scale: 1,
    },
  };
  result.usertags = m.usertags || [];
  result.product_tags = m.product_tags || [];
  result.story_mentions = m.story_mentions || [];
  result.story_hashtags = m.story_hashtags || [];
  result.location_sticker = m.location_sticker;
  // 如果type字段存在，说明是edit的图片
  if (m.type !== undefined) {
    result.from = "edit"; // 来源
  } else {
    // 如果沒有type則說明是add圖片，默認類型給圖片（type 1）
    result.type = 1;
  }
  return result;
}

/**
 * saved信息格式化
 * @param m save 信息
 * @returns {Post}
 */
export function formatSaveMediaItem(m) {
  const saved = new Post(m);
  return {
    ...saved,
    ...saved.images[0],
  };
}

/**
 * 根据图片参数进行裁切
 * @param cropImages 带裁切图片
 * @param changeImg 图片是否发生改变，如果发生改变则无需图片重新请求
 */
export async function cropImage({ cropImages, changeImg = true }) {
  // 如果存在一个类型变成add 则说明所有图片需要重新裁切
  if (cropImages.findIndex((i) => i.from === "edit") !== -1) {
    // 如果图片的key 不存在则说明是通过saved添加，需要重新上传原图片
    for (let i = 0; i < cropImages.length; i++) {
      const media = cropImages[i];
      // 如果图片没有Key则重新加载
      let reload = !media.key || !media.coverKey;
      if (reload) {
        console.log("media", media);
        const { data } = await axios.get(media.url, {
          responseType: "blob",
        });
        media.key = await uploadImg({ file: data });
        const { data: cover } = await axios.get(media.coverUrl, {
          responseType: "blob",
        });
        media.coverKey = await uploadImg({ file: cover });
      } else {
        // 如果图片变成add 模式也重新加载
        if (media.from === "add" && media.type === 1) {
          const blob = await exportImgByBlob({ model: cropImages[i].crop });
          media.coverKey = media.key = await uploadImg({
            file: blob,
            ins: true,
          });
        }
      }
    }
    return cropImages;
  }
  let images = [];
  for (let i = 0; i < cropImages.length; i++) {
    const currentImage = cropImages[i];
    let key = currentImage.mediaKey;
    let coverKey = currentImage.coverKey;
    // 如果是图片进行裁切操作
    if (currentImage.type === 1) {
      const blob = await exportImgByBlob({ model: cropImages[i].crop });
      if (changeImg) {
        coverKey = key = await uploadImg({ file: blob, ins: true });
      } else {
        key = coverKey;
      }
    }
    images.push({
      key,
      coverKey,
      type: currentImage.type,
      product_tags: currentImage.product_tags,
      usertags: currentImage.usertags,
      story_mentions: currentImage.story_mentions,
      story_hashtags: currentImage.story_hashtags,
      location_sticker: currentImage.location_sticker,
    });
  }
  return images;
}

/**
 * 导出图片
 */
export async function exportImage({ model }) {
  let image = new Image();
  image.crossOrigin = "anonymous";
  image.src = `${model.url}?t=${new Date().getTime()}`;
  await imageLoad({ image });
  // 初始化裁切所用canvas
  const rotateCanvas = document.createElement("canvas");
  const rotateCtx = rotateCanvas.getContext("2d");
  // 获取图片原始宽高
  const canvasW = image.width;
  const canvasH = image.height;
  // 图片进行翻转
  if (model.rotate === 0) {
    rotateCanvas.width = canvasW;
    rotateCanvas.height = canvasH;
    rotateCtx.drawImage(image, 0, 0, canvasW, canvasH);
  } else if (model.rotate === 90) {
    rotateCanvas.width = canvasH;
    rotateCanvas.height = canvasW;
    rotateCtx.rotate((90 * Math.PI) / 180);
    rotateCtx.drawImage(image, 0, -canvasH, canvasW, canvasH);
  } else if (model.rotate === 180) {
    rotateCanvas.width = canvasW;
    rotateCanvas.height = canvasH;
    rotateCtx.rotate((180 * Math.PI) / 180);
    rotateCtx.drawImage(image, -canvasW, -canvasH, canvasW, canvasH);
  } else if (model.rotate === 270) {
    rotateCanvas.width = canvasH;
    rotateCanvas.height = canvasW;
    rotateCtx.rotate((270 * Math.PI) / 180);
    rotateCtx.drawImage(image, -canvasW, 0, canvasW, canvasH);
  }
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  // 获取原始图片比例
  const imageRatio = rotateCanvas.width / rotateCanvas.height;
  let baseSize = 1;
  let cropX = 0;
  let cropY = 0;
  let cropWidth = 0;
  let cropHeight = 0;
  // 计算基准宽度
  if (imageRatio < 1) {
    baseSize = rotateCanvas.height;
  } else {
    baseSize = rotateCanvas.width;
  }
  cropWidth = baseSize / model.scale;
  cropHeight = baseSize / model.scale;
  // 如果开启lock模式则说明裁切比例不是1：1
  if (model.lock) {
    // 裁切宽大于高 则说明高度比短需要调整
    if (model.percentage > 1) {
      cropHeight = cropWidth / model.percentage;
    } else {
      cropWidth = cropHeight * model.percentage;
    }
  }
  cropX = (model.x * baseSize) / model.scale;
  cropY = (model.y * baseSize) / model.scale;
  // 如果开启lock模式则说明裁切比例不是1：1
  if (model.lock) {
    // 裁切宽大于高 则说明高度比短需要调整
    if (model.percentage > 1) {
      cropHeight = cropWidth / model.percentage;
      cropY -= (cropWidth - cropHeight) / 2;
    } else {
      cropWidth = cropHeight * model.percentage;
      cropX += (cropWidth - cropHeight) / 2;
    }
  } else {
    // 计算图片是否存在留白，如果留白则相应减少裁切宽度
    if (rotateCanvas.width * model.scale <= baseSize) {
      cropWidth = rotateCanvas.width;
      cropX = 0;
    }
    if (rotateCanvas.height * model.scale <= baseSize) {
      cropHeight = rotateCanvas.height;
      cropY = 0;
    }
  }
  // 如果原图正好符合标准则x y 为0 大小为图片大小
  canvas.width = cropWidth;
  canvas.height = cropHeight;
  // 如果图片本身就比较符合规则 那么进行原图裁切
  if (Math.abs(cropX) < 4) {
    cropX = 0;
  }
  if (Math.abs(cropY) < 4) {
    cropY = 0;
  }
  if (
    Math.abs(model.scale) < 0.05 &&
    Math.abs(cropX) < 4 &&
    Math.abs(cropY) < 4
  ) {
    cropX = cropY = 0;
    cropWidth = rotateCanvas.width;
    cropHeight = rotateCanvas.height;
  }
  cropX = parseInt(cropX);
  cropY = parseInt(cropY);
  cropWidth = parseInt(cropWidth);
  cropHeight = parseInt(cropHeight);
  ctx.drawImage(
    rotateCanvas,
    -cropX,
    -cropY,
    cropWidth,
    cropHeight,
    0,
    0,
    cropWidth,
    cropHeight
  );
  // 添加滤镜
  let currentCropImage = new Image();
  currentCropImage.src = canvas.toDataURL("image/jpeg");
  await imageLoad({ image: currentCropImage });
  const resultImg = imgFilter({ image: currentCropImage, type: model.filter });
  return resultImg;
}

/**
 * 根据裁切参数将图片导出成blob
 * @param model
 * @returns {Promise<void>}
 */
export async function exportImgByBlob({ model }) {
  const img = await exportImage({ model });
  const blob = await imageBlob({
    image: img,
  });
  return blob;
}

/**
 * 设置裁切所需图片(发现没有图片获取一下)
 * @param images 需要处理的图片
 * @param percentage 指定统一的裁切比例
 * @return {Promise<void>}
 */
export async function setCropImages({ images, percentage }) {
  let imgPercentage = percentage;
  // 视频不做处理
  const changeImages = images.filter((img) => img.type !== 2);
  // 获取每个多媒体图片，视频则放弃
  for (let index in changeImages) {
    const img = changeImages[index];
    // 没有图片说明是新的，所以需要获取图片 初始化位置
    if (!img.crop.image) {
      let image = new Image();
      image.crossOrigin = "anonymous";
      image.src = `${changeImages[index].crop.url}?t=${new Date().getTime()}`;
      await imageLoad({ image });
      img.crop.image = image;
      // 如果没传比例则获取图片比例
      if (imgPercentage === undefined) {
        imgPercentage = getImageCropPercentage({ model: img.crop });
      }
      img.crop.percentage = imgPercentage;
      if (images.length > 1 || percentage !== undefined) {
        // 如果多媒体数量大于1则说明肯定是锁定比例
        img.crop.lock = true;
      } else {
        img.crop.lock = false;
      }
      // 新的图片重新初始化位置信息(居中)
      const params = await getInitImgParams({ model: img.crop });
      img.crop.x = params.x;
      img.crop.y = params.y;
      img.crop.scale = params.minScale;
      img.crop.percentage = params.percentage;
    }
  }
}
